import React from 'react';

import cn from 'classnames';

import { AdminConversationCategoriesList } from '@features/AdminConversationCategoriesList';
import { AdminConversationCategoryUpsertModal } from '@features/AdminConversationCategoryUpsertModal';
import { ConversationClientModal } from '@features/ConversationClientModal';
import { AdminConversationHeader } from '@widgets/AdminConversationHeader';

import cls from './AdminConversation.module.css';
import { useAdminConversation } from '../lib/hooks/useAdminConversation';

interface AdminConversationProps {
    classes?: string;
}

export const AdminConversation = ({ classes }: AdminConversationProps) => {
    useAdminConversation();

    return (
        <div className={cn(cls.AdminConversation, [classes])}>
            <AdminConversationHeader />
            <AdminConversationCategoriesList />
        </div>
    );
};
